const PHRASE_REPLACEMENTS = [
  ['在地化', '本地化'],
  ['資訊', '信息'],
  ['資料', '数据'],
  ['應用程式', '应用'],
  ['商店', '商店'],
  ['評分數', '评分数'],
  ['下載數', '下载量'],
  ['即時', '实时'],
  ['排行榜', '排行榜'],
  ['代理指標', '代理指标'],
  ['公開訊號', '公开信号'],
  ['啟發式', '启发式'],
  ['免登入', '免登录'],
  ['開發者', '开发者'],
  ['類別', '类别'],
  ['類型', '类型'],
  ['瀏覽', '浏览'],
  ['搜尋', '搜索'],
  ['複製', '复制'],
  ['連結', '链接'],
  ['建置', '构建'],
  ['剪貼簿', '剪贴板'],
  ['變更', '变更'],
  ['檢查', '检查'],
  ['快取', '缓存'],
  ['網路', '网络'],
  ['沙烏地阿拉伯', '沙特阿拉伯'],
  ['阿聯酋', '阿联酋'],
  ['熱門', '热门'],
  ['暢銷榜', '畅销榜'],
  ['覆蓋', '覆盖'],
  ['分佈', '分布'],
  ['連線', '连接'],
  ['訊號', '信号'],
  ['預設', '默认'],
  ['儲存', '保存'],
  ['均執行', '均运行'],
  ['設定 Proxy', '配置 Proxy'],
];

const CHAR_REPLACEMENTS = Object.freeze({
  佔: '占',
  來: '来',
  亞: '亚',
  個: '个',
  們: '们',
  偵: '侦',
  優: '优',
  內: '内',
  兩: '两',
  並: '并',
  價: '价',
  冊: '册',
  冪: '幂',
  則: '则',
  創: '创',
  勢: '势',
  區: '区',
  協: '协',
  單: '单',
  啟: '启',
  動: '动',
  國: '国',
  圖: '图',
  報: '报',
  場: '场',
  增: '增',
  壓: '压',
  壞: '坏',
  夠: '够',
  將: '将',
  專: '专',
  對: '对',
  導: '导',
  屆: '届',
  層: '层',
  屬: '属',
  建: '建',
  帳: '账',
  廣: '广',
  後: '后',
  從: '从',
  敗: '败',
  復: '复',
  徵: '征',
  應: '应',
  戲: '戏',
  戶: '户',
  據: '据',
  擇: '择',
  攝: '摄',
  數: '数',
  斷: '断',
  時: '时',
  暫: '暂',
  暢: '畅',
  會: '会',
  東: '东',
  業: '业',
  極: '极',
  標: '标',
  樣: '样',
  機: '机',
  檔: '档',
  檢: '检',
  歐: '欧',
  歷: '历',
  減: '减',
  測: '测',
  滿: '满',
  漲: '涨',
  潛: '潜',
  為: '为',
  無: '无',
  營: '营',
  獲: '获',
  熱: '热',
  現: '现',
  畫: '画',
  異: '异',
  當: '当',
  發: '发',
  盃: '杯',
  盜: '盗',
  監: '监',
  灣: '湾',
  盤: '盘',
  眾: '众',
  碼: '码',
  礎: '础',
  程: '程',
  積: '积',
  競: '竞',
  筆: '笔',
  節: '节',
  築: '筑',
  範: '范',
  簽: '签',
  簡: '简',
  精: '精',
  級: '级',
  紐: '纽',
  組: '组',
  結: '结',
  絕: '绝',
  統: '统',
  稱: '称',
  經: '经',
  維: '维',
  網: '网',
  線: '线',
  編: '编',
  緩: '缓',
  總: '总',
  縮: '缩',
  繁: '繁',
  義: '义',
  羅: '罗',
  聯: '联',
  聲: '声',
  職: '职',
  臺: '台',
  與: '与',
  舊: '旧',
  蓋: '盖',
  藏: '藏',
  號: '号',
  處: '处',
  虛: '虚',
  術: '术',
  補: '补',
  裝: '装',
  製: '制',
  覆: '覆',
  見: '见',
  規: '规',
  視: '视',
  覽: '览',
  觀: '观',
  觸: '触',
  計: '计',
  訊: '讯',
  設: '设',
  訪: '访',
  評: '评',
  試: '试',
  詞: '词',
  該: '该',
  詢: '询',
  詳: '详',
  認: '认',
  語: '语',
  誤: '误',
  說: '说',
  語: '语',
  調: '调',
  請: '请',
  論: '论',
  週: '周',
  證: '证',
  讀: '读',
  變: '变',
  貝: '贝',
  負: '负',
  財: '财',
  責: '责',
  參: '参',
  費: '费',
  資: '资',
  賴: '赖',
  這: '这',
  贏: '赢',
  趨: '趋',
  跡: '迹',
  跨: '跨',
  較: '较',
  載: '载',
  輯: '辑',
  輸: '输',
  轉: '转',
  辦: '办',
  運: '运',
  過: '过',
  達: '达',
  遞: '递',
  選: '选',
  進: '进',
  還: '还',
  部: '部',
  配: '配',
  醫: '医',
  釋: '释',
  針: '针',
  錄: '录',
  錯: '错',
  銷: '销',
  閉: '闭',
  鍵: '键',
  長: '长',
  門: '门',
  開: '开',
  間: '间',
  關: '关',
  階: '阶',
  隊: '队',
  雙: '双',
  離: '离',
  難: '难',
  韓: '韩',
  靜: '静',
  態: '态',
  電: '电',
  霧: '雾',
  蹤: '踪',
  頁: '页',
  項: '项',
  順: '顺',
  預: '预',
  領: '领',
  頭: '头',
  題: '题',
  額: '额',
  類: '类',
  顯: '显',
  飲: '饮',
  體: '体',
  馬: '马',
  點: '点',
  閱: '阅',
  連: '连',
  匯: '汇',
  僅: '仅',
  儲: '储',
  執: '执',
  淺: '浅',
  沒: '没',
  氣: '气',
  係: '系',
  隸: '隶',
  陸: '陆',
  蘭: '兰',
});

/**
 * Convert the shipped Traditional Chinese copy into Simplified Chinese.
 * This is intentionally scoped to UI catalog text and country/genre labels.
 *
 * @param {string} value
 * @returns {string}
 */
export function toSimplifiedChinese(value) {
  let next = String(value);
  for (const [from, to] of PHRASE_REPLACEMENTS) {
    next = next.replaceAll(from, to);
  }
  return Array.from(next, (ch) => CHAR_REPLACEMENTS[ch] ?? ch).join('');
}

/**
 * @param {Record<string, string>} catalog
 * @param {Record<string, string>} [overrides]
 * @returns {Record<string, string>}
 */
export function simplifyCatalog(catalog, overrides = {}) {
  return Object.freeze(Object.fromEntries(
    Object.entries({ ...catalog, ...overrides }).map(([key, value]) => [key, toSimplifiedChinese(value)]),
  ));
}
